import { useMemo } from 'react';
import { getBrowserLocale } from './language';

export const STEP_OFFER = 'offer';
export const STEP_FINAL = 'final';
export const OFFER_STATUS_AVAILABLE = 'available';
export const OFFER_TYPE_OMEGA3 = 'omega3';
export const OFFER_TYPE_FORMULA_ABO_UPGRADE = 'formula_abo_upgrade';

export const getInitialStep = (postPurchaseUpsell) =>
  postPurchaseUpsell?.status === OFFER_STATUS_AVAILABLE ? STEP_OFFER : STEP_FINAL;

export const formatTimer = (ms) => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
};

export const usePriceFormatter = (language) =>
  useMemo(
    () =>
      new Intl.NumberFormat(getBrowserLocale(language), {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }),
    [language],
  );
